import { getFormattedTodaysDate } from '../../../services/common/validation';
import { AddressFormModel_MX } from './formModel';

export const getInitialValues = (isConsumerOrSoleTrader: boolean): AddressFormModel_MX => {
  return {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    eirCode: '',
    town: '',
    county: '',
    ...(isConsumerOrSoleTrader
      ? {
          residentialStatus: '',
          timeAtAddressFrom: '',
          timeAtAddressTo: getFormattedTodaysDate(),
        }
      : {}),
  };
};
